module.exports = __webpack_public_path__ + "img/project-map.b8857eae.png";